import React, { useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { parse } from "query-string";
import I18n from "../../I18n";
import { mapProperties } from "colbi_web_ui/lib/utils";
import {
    logout,
    pushModal,
    pushDialog,
    popModal,
    toggleMenu,
    setLocale,
    removeModal,
    saveWorkerAssociationPackageAction,
} from "../../store/actions";

import { LoadingIndicator } from "colbi_web_ui/lib/components";
import { SovosPageLayout, SovosPageContentGeneric } from "mosaic-react";
import ModalController from "../App/ModalController/ModalController";

import styles from "./Settings.module.sass";

import { UserRoles } from "../../enums/userRoles";
import MainTabs from "../App/MainTabs/MainTabs";
import {
    decodeUserSession,
    buildStaticLinks,
    redirectNotValid,
    BuildSovosNavProps,
} from "../../utils/utils";

import { checkAccessByRole } from "../../utils/roleValidatorUtil";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import { useAuth } from "react-oidc-context";
import { generateSettingsMenuItems } from "../../components/GlobalLayout/menuBuilderUtils";

const PackagesAssociation = (props) => {
    const { user, fetch, match, setLocale, location, history, route, modules } = props;

    const locale = match.params.locale || "en";
    const i18n = I18n.use(locale);

    const auth = useAuth();

    useEffect(() => {
        setLocale(locale);
    }, [locale, setLocale]);

    const userInformation = decodeUserSession(user);

    const menuItems = generateSettingsMenuItems(userInformation?.role, history, locale, i18n) || [];

    const navigation = menuItems;

    const setupLinks = buildStaticLinks(navigation, history, match.params, i18n);

    const redirect = redirectNotValid(userInformation, locale, true, auth);

    if (redirect) {
        return redirect;
    }

    const isAdminRoles = !checkAccessByRole(userInformation, [
        UserRoles.OWNER,
        UserRoles.READER,
        UserRoles.WRITER,
    ]);

    if (!(userInformation && userInformation.accessSettings) || !isAdminRoles) {
        return <Redirect to={`/${locale}/unauthorized`} />;
    }

    navigation.forEach((elem) => {
        elem.name = I18n.translate`${elem.name}`;
        return elem;
    });

    const queryParams = parse(location.search) || {};
    const routeParams = match.params || {};
    const params = {
        ...queryParams,
        ...routeParams,
    };

    const routeQueries = (route.queries && route.queries(params)) || [];

    let displayComponents = [];

    displayComponents.push(...route.components);

    const children = displayComponents.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            (fetch || {}).results,
            (fetch || {}).status,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );
        const componentProps = {
            ...componentParsedProps,
            modules,
        };

        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    });

    const navProps = BuildSovosNavProps(
        undefined,
        [],
        { name: "" },
        {},
        userInformation,
        setupLinks || [],
    );

    const globalLayoutProps = {
        ...props,
        navProps,
        params,
        staticLinks: setupLinks,
        styles,
    };

    return (
        <GlobalLayout {...globalLayoutProps}>
            <SovosPageLayout pageTitle={i18n`Packages Association`}>
                <SovosPageContentGeneric>
                    <>
                        {fetch.activity && (
                            <LoadingIndicator className={`${styles["loading-indicator"]}`} />
                        )}
                        {children}
                        {route.routes && route.routes.length > 1 && (
                            <MainTabs
                                className={styles["tabs"]}
                                routes={route.routes}
                                params={match.params}
                            />
                        )}
                        {renderRoutes(route.routes)}
                        <ModalController />
                    </>
                </SovosPageContentGeneric>
            </SovosPageLayout>
        </GlobalLayout>
    );
};

export default connect(
    ({ user, fetch, menu, uploads }) => ({
        user,
        fetch,
        menu,
        uploads,
    }),
    {
        toggleMenu,
        logout,
        setLocale,
        pushModal,
        popModal,
        removeModal,
        pushDialog,
        saveWorkerAssociationPackage: saveWorkerAssociationPackageAction,
    },
)(withRouter(PackagesAssociation));
